import { combineReducers } from 'redux'

import cardsDots from './cardsDots'
import anchors from './anchors'

export default combineReducers({
  cardsDots,
  anchors
})
